const apyFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
})

export function formatApy(value: number): string {
  return `${apyFormatter.format(value)}%`
}
